<template>
  <Row style="height:700px;margin-top: 10px">
    <template>
      <div style="width: 100%">
        <Table border :columns="columns" :data="approvalstuats" style="width:100%;" stripe align="center">
        </Table>
        <div style="width:2px;height:20px;background-color:red;margin-top: 40px;display: inline-block;"></div>
        <p style="position: relative;top:-30px;margin-left:10px;font-weight: 700;font-size: 20px;"> 审批信息</p>
        <Table border :columns="approvalTabel" :data="approvalData" style="width:100%;" stripe align="center">
        </Table>
        <div style="width:2px;height:20px;background-color:red;margin-top: 40px;display: inline-block;"></div>
        <p style="position: relative;top:-30px;margin-left:10px;font-weight: 700;font-size: 20px;"> 用户信息</p>
        <Table border :columns="userTable" :data="userData" style="width:100%;" stripe align="center"></Table>
      </div>
    </template>
  </Row>
</template>
<script>
import baseList from '@/views/components/base/baseHospital.vue'
export default {
  extends: baseList,
  data() {
    return {
      table: {
        mname: "approvaldetails",
        key: "id",
        url: {
          list: `/admin/approve/selectDetail?id=${this.$route.query.id}`,
        },
        output: false,
        order: 'id',
        qrCode: "qrCode",
      },
      num: undefined,
      hospitaltype: "审批详情",
      tableCols: [],
      columns: [{
        align: 'center',
        title: '审批状态',
        render: (h, params, index) => {
          const status = params.row.approveStatus
          if (status == 0) {
            return <p style="color: red">驳回</p>
          } else if (status == 1) {
            return <p style="color: skyblue">审批中</p>
          } else if (status == 2) {
            return <p style="color: green">审批完成</p>
          }else if (status == 3) {
            return <p style="color: green">已撤回</p>
          }
        }
      }, {
        title: '审批流程',
        width: '1040%',
        render: (h, p) => {
          let current = this.num;
          if (this.num != 2&&this.num !=3) {
            return (
                <Steps current={current} >
                  <Step title="生成审批" content="等待审批"></Step>
                  <Step title="审批中" content="审批中请稍等"></Step>
                  <Step title="审批完成" content="审批完成稍后生成订单"></Step>
                </Steps>
            )
          } else if (this.num == 2) {
            return (
                <Steps current={current - 1} status='error'>
                  <Step title="生成审批" content="等待审批"></Step>
                  <Step title="被驳回" content="订单被驳回"></Step>
                  <Step title="审批完成" content="审批完成稍后生成订单"></Step>
                </Steps>
            )
          }else if (this.num == 3) {
            return (
                <Steps current={current - 2} status="error">
                  <Step title="生成审批" content="等待审批"></Step>
                  <Step title="已撤回" icon="" content="审批已撤回"></Step>
                  <Step title="审批完成" content="审批完成稍后生成订单"></Step>
                </Steps>
            )
          }}
      }],
      approvalstuats: [],

      // 审批详情数据
      approvalTabel: [{
        title: '审批编号',
        key: 'approveNumber',
        align: 'center',
      }, {
        title: '商品图片',
        align: 'center',
        width: 160,
        render: (h, p) => {
          let html = [];
          for (let i = 0; i < p.row.sysCommodityDto.length; i++) {
            html.push(
                <img src={this.loadimg(p.row.sysCommodityDto[i].commodityImage)} style="width:60px;height:60px;margin-top:10px;display:block" />
            );
          }
          return (
              <div>
                {html}
              </div>
          )
        }
      }, {
        title: '商品信息',
        align: 'center',
        width: 350,
        render: (h, p) => {

          let html = [];
          for (let i = 0; i < p.row.sysCommodityDto.length; i++) {
            html.push(
                <div style="border-top:1px solid rgb(232, 234, 236);">
                  <img src={this.loadimg(p.row.sysCommodityDto[i].commodityImage)} style="width:60px;height:60px;float:left;margin-right:30px;margin-top:5px" />
                  <div style="padding:15px">
                    <p style="text-align:left">商品名称：{p.row.sysCommodityDto[i].commodityName}</p>
                    <p style="text-align:left">商品编号：{p.row.sysCommodityDto[i].commodityNumber}</p>
                  </div>
                </div>
            );
          }
          return (
              <div>
                {html}
              </div>
          )
        }
      }, {
        title: '审批状态',
        align: 'center',
        width:100,
        render: (h, params, index) => {
          const status = params.row.approveStatus
          if (status == 0) {
            return <p style="color: red">驳回</p>
          } else if (status == 1) {
            return <p style="color: skyblue">审批中</p>
          } else if (status == 2) {
            return <p style="color: green">审批完成</p>
          }else if (status == 3) {
            return <p style="color: green">已撤回</p>
          }
        }
      }, {
        title: '申请数量',
        align: 'center',
        width:100,

        render: (h, p) => {
          let html = [];
          for (let i = 0; i < p.row.sysCommodityDto.length; i++) {
            html.push(
                <p style="margin:26px 0px">{p.row.sysCommodityDto[i].commodityQuantity}</p>
            );
          }
          return (
              <div >
                {html}
              </div>
          )
        }
      }, {
        title: '申请部门',
        key: 'deskName',
        align: 'center',
        width:100,

      }, {
        title: '残余库存',
        align: 'center',
        width:100,

        render: (h, p) => {
          let html = [];
          for (let i = 0; i < p.row.sysCommodityDto.length; i++) {
            html.push(
                <p style="margin:26px 0px">{p.row.sysCommodityDto[i].commodityRepertory}</p>
            );
          }
          return (
              <div >
                {html}
              </div>
          )
        }
      }, {
        title: '备注',
        align: 'center',
        width:100,

        render: (h, p) => {
          return (
              <p>无</p>
          )
        }
      }, {
        title: '操作',
        align: 'center',
        render: (h, params) => {
          if (params.row.approveStatus == 2) {
            return (<p style="color:green">已通过</p>)
          } else if (params.row.approveStatus == 1) {
            return (
                <Space direction="vertical">
                  <Space wrap>
                    <Button type="success" onclick={() => this.approvalPass(params)} >通过</Button>
                    <Button type="error" onclick={() => this.overrule(params)}>驳回</Button>
                  </Space>
                </Space>
            );
          } else if (params.row.approveStatus == 0) {
            return (<p style="color:red">驳回</p>)
          }

        }
      },],

      approvalData: [],
      // 用户信息数据
      userTable: [{
        title: '用户Id',
        key: 'userId',
        align: 'center',
        width: 200,
        height: 200
      },
        {
          title: '用户头像',
          align: 'center',
          width: 150,
          height: 200,
          render: (h, params) => {
            return (<div >
              <img src={this.loadimg(params.row.avatar)}   style="width:60px;height:60px;margin:10px;border-radius:50%" />
            </div>)
          },
        },
        {
          title: '用户信息',
          key: 'name',
          align: 'center',
          width: 300,
          height: 200,
          render: (h, params) => {
            return (
                <div style="padding:1px 0 1px 0 ">
                  <span style="float:left;margin-left:30px">用户名称：{params.row.nickName}</span><br />
                  <span style="float:left;margin-left:30px">所属医院：第八人民医院</span>
                  <span style="float:left;margin-left:30px">联系方式：{params.row.phonenumber}</span>
                </div>)
          },
        },
        {
          title: '收货信息',
          align: 'center',
          width: 400,
          height: 200,
          render: (h, params) => {
            return (<div>
              <span style="float:left;margin-left:30px">收货人：{params.row.consigneeName}</span><br />
              <span style="float:left;margin-left:30px">联系方式：{params.row.consigneePhone}</span><br />
              <span style="float:left;margin-left:30px">收货地址：{params.row.consigneeAddress}</span>
            </div>)
          },
        },
        {
          title: '申请方式',
          align: 'center',
          height: 200,
          render: (h, params) => {
            return (
                <p>线上</p>
            )
          },
        },
        {
          title: '申请科室',
          key: 'deskName',
          align: 'center',
          height: 200,
        },
        {
          title: '申请时间',
          key: 'createTime',
          align: 'center',
          height: 200,
        },
      ],
      userData: [

      ],




      filters: [
        // {label: '返回', name: '', value: '', type: 'revert'},
        // {label: '', name: 'search', value: '', type: 'input'},
      ],
      menus: [
        { label: '商品列表', name: 'hospitalbackstage_list', auth: '/admin/hospitalbackstage/list' },
        { label: '审批中心', name: 'approvalcenter_list', auth: '/admin/approvalcenter/list' },
        { label: '订单中心', name: 'scene_list', auth: 'system/scene/index' },
      ]
    }
  },

  async created() {
    let result = await $utils.api.load(this.table.url.list)
    this.tableCols = result.data
    let data = result.data
    this.changeData(data)
  },
  methods: {
    changeData(e) {
      this.approvalstuats.push({ approveStatus: e.approveStatus })
      if (e.approveStatus == 1) {
        this.num = e.approveStatus
      } else if (e.approveStatus == 2) {
        this.num = 4
      } else if (e.approveStatus == 0){
        this.num = 2
      }else{
        this.num =3
      }


      // for (let index = 0; index < e.sysCommodityDto.length; index++) {
      this.approvalData.push({
        id: e.id,
        approveNumber: e.approveNumber,
        sysCommodityDto: e.sysCommodityDto,
        deskName: e.deskName,
        approveStatus: e.approveStatus
      })
      // }


      this.userData.push({
        userId: e.user.userId,
        avatar: e.user.avatar,
        nickName:e.user.nickName,
        phonenumber : e.user.phonenumber,

        consigneePhone: e.sysConsignee[0].consigneePhone,
        consigneeAddress: e.sysConsignee[0].consigneeAddress,
        consigneeName: e.sysConsignee[0].consigneeName,
        deskName: e.deskName,
        createTime: e.createTime
      })
    },
    // 通过
    approvalPass(e) {
      this.approvalstuats[0].approveStatus = e.row.approveStatus + 1
      // 审批状态
      e.row.approveStatus = e.row.approveStatus + 1
      // 审批流程图
      this.num = 4
      let p = {}
      p.id = e.row.id
      p.approveStatus = e.row.approveStatus
      $utils.api
          .load(`/admin/approve/updateStatus`, p, 'get')
          .then((res) => {
            if (res.status) {
              $utils.toast.success('保存成功')
            }
          })
          .catch((e) => {
            $utils.toast.error('保存异常' + e.message)
          })
    },
    // 驳回
    overrule(e) {
      // 审批状态
      this.approvalstuats[0].approveStatus = 0
      e.row.approveStatus = 0
      this.num = 2
      let p = {}
      p.id = e.row.id
      p.approveStatus = 0
      $utils.api.load(`/admin/approve/updateStatus`, p, 'get')
          .then((res) => {
            if (res.status) {
              $utils.toast.success('保存成功')
            }
          })
          .catch((e) => {
            $utils.toast.error('保存异常' + e.message)
          })
    },

  }
}
</script>